var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeachHoliday = function SvgBeachHoliday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75779 3.81068L7.0166 4.7766M9.58994 18.244L8.56955 10.5721",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5237 9.49584C14.8891 9.1763 14.1392 9.07969 13.3989 9.27805C12.391 9.54812 11.6411 10.3006 11.3312 11.2205C10.6029 10.5788 9.57722 10.3021 8.56929 10.5721C7.56136 10.8422 6.81151 11.5947 6.50158 12.5146C5.77322 11.8729 4.74759 11.5962 3.73967 11.8662C2.99937 12.0646 2.39829 12.5232 2.00848 13.1172C1.15866 9.45746 3.35961 5.75642 7.01638 4.77659C10.6732 3.79676 14.4297 5.90149 15.5237 9.49584Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1364 6.79534C18.5882 6.70744 18.8832 6.26993 18.7953 5.81812C18.7074 5.36631 18.2699 5.07131 17.8181 5.15921C17.3663 5.2471 17.0713 5.68462 17.1592 6.13643C17.2471 6.58823 17.6846 6.88324 18.1364 6.79534Z",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 2.40076L17.4908 3.38235",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5728 8.9447L18.7637 9.9263",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.959 3.94958L15.5 4.50012",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4858 7.67615L21.6584 8.46678",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9448 5.427L21.9264 5.23604",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7769 4.03103L20.5675 2.85847",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H21C18.443 19.108 15.3422 18 12 18C8.65779 18 5.55702 19.108 3 21Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgBeachHoliday;